import { render, staticRenderFns } from "./ItemEditForm.vue?vue&type=template&id=14288ebd&lang=html&"
import script from "./ItemEditForm.vue?vue&type=script&lang=js&"
export * from "./ItemEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports